export default function menuHidden() {
    if (document.querySelector(".menu-hidden")) {
        let menu = document.querySelector(".main-header");

        menu.style.display = "none";
    }
}
